import api from './axiosInstance';

export interface InviteInfo {
  email: string;
  role: string;
  organizationName: string;
}

export interface Invite {
  _id: string;
  email: string;
  role: string;
  expiresAt: string;
}

export const getInvite = async (token: string): Promise<InviteInfo> => {
  const { data } = await api.get<InviteInfo>(`/invites/token/${token}`);
  return data;
};

export const acceptInvite = async (payload: {
  token: string;
  firstName: string;
  lastName: string;
  password: string;
  acceptedTerms?: boolean;
}): Promise<{ message: string }> => {
  const { data } = await api.post<{ message: string }>('/invites/accept', payload);
  return data;
};

export const createInvite = async (payload: {
  email: string;
  role: 'admin' | 'editor' | 'viewer';
}): Promise<{ invite: { inviteUrl: string; email: string; role: string } }> => {
  const { data } = await api.post('/invites', payload);
  return data;
};

export const listInvites = async (): Promise<Invite[]> => {
  const { data } = await api.get<Invite[]>('/invites');
  return data;
};

export const revokeInvite = async (id: string): Promise<void> => {
  await api.delete(`/invites/${id}`);
};
